import { request } from '../../lib/request_mock';
// import { encrypt } from '@cekit/utils';
import settings from 'settings';

const { tokenType } = settings

// 登陆
export async function login(data) {
    // 是否采用RSA
    // data = await encrypt.encryptedData(data);
    return request({
        url: '/login',
        method: 'post',
        data,
    });
}

// 获得用户信息
export function getUserInfo(accessToken) {
    return request({
        url: '/userInfo',
        method: 'post',
        data: {
            [tokenType]: accessToken,
        },
    });
}

// 注销
export function logout() {
    return request({
        url: '/logout',
        method: 'post',
    });
}

// 注册
export function register() {
    return request({
        url: '/register',
        method: 'post',
    });
}
